export enum ELabelColor {
  Gray = 'gray',
  DarkGray = 'dark-gray',
  Green = 'green',
  Red = 'red',
  Yellow = 'yellow',
  /** Синий с иконкой Циан */
  Blue = 'blue',
  /** Синий без иконки Циан */
  SimpleBlue = 'simpleBlue',
  DarkBlue = 'darkBlue',
  BlackBlueGradient = 'blackBlueGradient',
  /** Фиолетовый с иконкой */
  Purple = 'purple',
}

export type TLabelColor = `${ELabelColor}`;

export interface ILabelTooltip {
  title: string;
  description: React.ReactNode;
  onOpen?: () => void;
}

export interface ILabel {
  color: ELabelColor;
  text: string;
  tooltip?: ILabelTooltip;
}
